import TransactionConfirmationModal, { TransactionErrorContent } from 'components/TransactionConfirmationModal'
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useCallback, useState } from 'react'

const defaultState = {
  showConfirm: false,
  attempting: false,
  hash: '',
  txError: '',
  pendingText: '',
}

interface TransactionConfirmationContextType {
  transactionData: typeof defaultState
  setTransactionData: Dispatch<SetStateAction<typeof defaultState>>
}

export const TransactionConfirmationContext = createContext<TransactionConfirmationContextType>({
  transactionData: defaultState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setTransactionData: (state: SetStateAction<typeof defaultState>) => undefined,
})

export const TransactionConfirmationProvider = ({ children }: PropsWithChildren) => {
  const [transactionData, setTransactionData] = useState(defaultState)

  const onDismiss = useCallback(() => {
    setTransactionData(defaultState)
  }, [])

  return (
    <TransactionConfirmationContext.Provider value={{ transactionData, setTransactionData }}>
      <TransactionConfirmationModal
        isOpen={transactionData.showConfirm}
        onDismiss={onDismiss}
        attemptingTxn={transactionData.attempting}
        hash={transactionData.hash}
        pendingText={transactionData.pendingText}
        content={() =>
          transactionData.txError && <TransactionErrorContent onDismiss={onDismiss} message={transactionData.txError} />
        }
      />
      {children}
    </TransactionConfirmationContext.Provider>
  )
}
